export default {
  methods: {
    getBlockIdFromElement: function (sourceId) {
      if (document.getElementById(sourceId)) {
        return document.getElementById(sourceId).getAttribute('block_id')
      } else {
        return null
      }
    },
    getTemplateIdFromElement: function (sourceId) {
      if (document.getElementById(sourceId)) {
        return document.getElementById(sourceId).getAttribute('template_id')
      } else {
        return null
      }
    },
    getElementIdFromElement: function (sourceId) {
      if (document.getElementById(sourceId)) {
        return document.getElementById(sourceId).getAttribute('element_id')
      } else {
        return null
      }
    }
  }
}
